<template>
  <div>
  <div class="relative business-type-wrapper"  id="business-type">
    <v-select
      v-model="businessType"
      :items="typesList.filter(type => type.show)"
      item-text="title"
      :rules="rules.select"
      item-value="id"
      label="Choose a Business Type"
      single-line
      append-icon="mdi-chevron-down"
    >
    <template v-slot:item="data">
      <p class="v-list-item__title" :id="data.item.id">{{ data.item.title }}</p>
    </template>
  </v-select>
  </div>
    <div class="mobile-select-subtype-title" v-if="isMobile && nestedBusinessTypeData">
     {{ mobileSelectSubtypeTitle }}
    </div>
    <v-radio-group v-if="nestedBusinessTypeData" v-model="finalIncomeType">
      <div class="btns-wrapper">
        <button
          @click="handleNestedTypeSelection(data)"
          v-if="nestedBusinessTypeData"
          v-for="data in nestedBusinessTypeData"
          :id="data.value"
          :class="finalIncomeType === data.value ? 'active' : ''" class="selectable-nested-type fade-in">
          {{data.title}}
        </button>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'BusinessTypeForm',
  watch: {
    businessType (newBusinessType) {
      if (!newBusinessType) {
        this.finalIncomeType = ''
        return
      }
      const typeIdx = this.typesList.findIndex(type => type.id === newBusinessType)
      const incomeType = this.typesList[typeIdx].incomeType
      if (incomeType) {
        this.finalIncomeType = incomeType
      } else {
        this.finalIncomeType = ''
        this.$store.commit('customer/setKeyValue', {prop: 'businessType', value: newBusinessType})
      }
    },
    finalIncomeType (newIncomeType) {
      const typeIdx = this.typesList.findIndex(type => type.id === this.businessType)
      const incomeTitle = this.typesList[typeIdx].title
      if (newIncomeType) {
        this.$store.commit('customer/setKeyValue', {prop: 'incomeType', value: {id: this.businessType, title: incomeTitle, enum: newIncomeType}})
      } else {
        this.$store.commit('customer/setKeyValue', {prop: 'incomeType', value: {id: this.businessType, title: incomeTitle, enum: null}})
      }
    }
  },
  mounted () {
    if (this.customerData.incomeType.enum) {
      const businessEnum = this.customerData.incomeType.enum

      switch (businessEnum) {
        case 'LLC':
        case 'MMLLC':
          this.businessType = 'llc'
          break

        case 'DBA':
        case 'SSN':
          this.businessType = 'sole'
          break

        case 'GENERAL_PARTNERSHIP':
        case 'LLP':
          this.businessType = 'partner'
          break

        case 'S_CORP':
          this.businessType = 'Scorp'
          break
      }
      setTimeout(() => {
        this.finalIncomeType = businessEnum
        this.$store.commit('customer/setKeyValue', {prop: 'businessType', value: businessEnum})
      }, 100)
    }
  },
  methods: {
    clearFieldError (field) {
      this.$store.dispatch('errors/clearSpecificFieldError', [
        'defaultError',
        field
      ])
    },
    handleNestedTypeSelection (data) {
      this.clearFieldError('finalType')
      this.finalIncomeType = data.value
    }
  },
  computed: {
    nestedBusinessTypeData () {
      if (this.businessType === 'llc') {
        return [
          {title: 'Single-Member LLC', value: 'LLC'},
          {title: 'Multi-Member LLC', value: 'MMLLC'}
        ]
      } else if (this.businessType === 'sole') {
        return [
          {title: 'I have a DBA', value: 'DBA'},
          {title: ' I don’t have a DBA', value: 'SSN'}
        ]
      } else if (this.businessType === 'partner') {
        return [
          {title: 'General Partnership', value: 'GENERAL_PARTNERSHIP'},
          {title: 'Limited Liability Partnership', value: 'LLP'}
        ]
      }
    },
    mobileSelectSubtypeTitle () {
      if (this.isMobile && this.businessType === 'llc') {
        return 'Select your LLC type'
      } else if (this.isMobile && this.businessType === 'sole') {
        return 'Do you have a DBA (doing business as) name?'
      } else if (this.isMobile && this.businessType === 'partner') {
        return 'Select your partnership type'
      }
    },
    customerData () {
      return this.$store.getters['customer/data']
    },
    formFieldsErrors () {
      return this.$store.getters['errors/fieldErrors']
    },
    hasSoleProprietor () {
      return this.customerData.hasSoleProprietor
    },
    isMobile () {
      return this.$store.getters['onboarding/isMobile']
    },
    typesList () {
      return [
        {
          title: 'Corporation (S-Corp)',
          id: 'Scorp',
          incomeType: 'S_CORP',
          show: true
        },
        {
          title: 'Partnership',
          id: 'partner',
          incomeType: '',
          show: true
        },
        {
          title: 'Limited Liability Company (LLC)',
          id: 'llc',
          incomeType: '',
          show: true
        },
        {
          title: 'Sole Proprietor',
          id: 'sole',
          incomeType: '',
          show: !this.hasSoleProprietor
        }
      ]
    }
  },
  data: () => {
    return {
      businessType: '',
      finalIncomeType: '',
      rules: {
        select: [v => !!v || 'Business type is required']
      }
    }
  }
}
</script>

<style lang="css" scoped>
.btns-wrapper {
  display: flex;
  align-items: center;
  gap: 29px;
}
.theme--light.v-messages {
  color: red !important;
}
.business-type-wrapper {
  width: 327px;
}

@media only screen and (max-width: 480px) {
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .business-type-wrapper {
    width: 100%;
  }

  .mobile-select-subtype-title {
    margin-top: 8px;
    color: #525D71;
    font-family: MetricRRegular;
    font-size: 16px;
    line-height: 150%; /* 24px */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/business-sections/BusinessTypeForm.vue